import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/credit-open-list',
            name: 'admin-credit-open-list',
            component: () => import(/* webpackChunkName: "page-admin-credit-management-credit-open-list" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "开通授信"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信管理"
                                        },
                                        {
                                                  name: "开通授信"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
